// extracted by mini-css-extract-plugin
export default {"footer":"dY0X32yT"};